export default __webpack_public_path__ + "static/media/I0002.5d1f5781.png";